/**
 * Airship feature flag manager.
 */
export class AirshipFeatureFlagManager {
    constructor(plugin) {
        this.plugin = plugin;
    }
    /**
      * Retrieve a given flag's status and associated data by its name.
      * @param {string} flagName The flag name
      * @return {Promise<FeatureFlag>} A promise resolving to the feature flag
      *   requested.
      * @throws {Error} when failed to fetch
      */
    flag(flagName) {
        return this.plugin.perform('featureFlagManager#flag', flagName);
    }
    /**
      * Tracks a feature flag interaction event.
      * @param {FeatureFlag} flag The flag
      * @return {Promise<Void>} A promise with an empty result.
      * @throws {Error} when failed to fetch
      */
    trackInteraction(flag) {
        return this.plugin.perform('featureFlagManager#trackInteraction', flag);
    }
}
//# sourceMappingURL=AirshipFeatureFlagManager.js.map